<template>
  <div style="padding: 10px 14px">
    <h3>User Privacy Agreement</h3>
    <p>
      <strong>
        Please read this guide carefully and ensure you understand our rules for handling your personal information. If you have any questions while reading this guide, please
        contact us. If you understand and agree to accept this guide, you can click "Agree" to start using our services. If you do not agree with any of the terms in this
        guide, please stop accessing and using it immediately.
      </strong>
    </p>
    <strong><p>1.Scope of application of privacy Agreement</p></strong>
    <p>（1）Personal identity information left by you when using the application server;</p>
    <p>（2）Various information transmitted between you and others through the application server;</p>
    <p>（3）Other information shared by the Application with business partners, which is yours or not yours;</p>
    <p>
      （4）{{ activationCompany.abbreviation }} Software attaches great importance to the protection of your personal privacy, and has formulated the User Privacy Agreement.
      You can also use the User Privacy Agreement. You confirm and agree that using the services provided by {{ activationCompany.abbreviation }} Software will be regarded as
      accepting the User Privacy Agreement.
    </p>
    <strong><p>2.Description of user information collection and use</p></strong>
    <strong>
      <p>
        <u>
          2.1 When you register and log in, we will collect your personal information, including but not limited to nickname, profile picture, phone number, WeChat, QQ, etc.,
          to help you complete registration, login, and use software services, and protect the security of your account; we will collect and use the phone numbers you upload
          yourself for follow-up calls and event notifications.
        </u>
      </p>
    </strong>
    <strong>
      <u>
        <p>
          2.2 After registration is complete, you can choose to provide the following personal information: your school type, educational stage (e.g., primary school, middle
          school, high school), and subject information (e.g., Chinese, mathematics, English). To enhance recognizability, nicknames and educational stage subject information
          will be publicly displayed (for example, after uploading or downloading a presentation from the library, it will be shown in the library). If you do not provide this
          information, it will not affect your use of the basic functions of the software.
        </p>
      </u>
    </strong>
    <strong>
      <u>
        <p>
          2.3 Some of our services may require you to provide specific personal sensitive information to achieve certain functions. If you choose not to provide such
          information, you may be unable to use certain features of the service normally, but this will not affect your ability to use other features of the service. By
          voluntarily providing your personal sensitive information, you agree that we can process it for the purposes and uses outlined in this agreement or other prompts.
        </p>
      </u>
    </strong>
    <p>
      2.4 When collecting and using the above information, we will need to obtain relevant permissions from you: such as camera, album, microphone; all these permissions will
      not be enabled by default, and can only be granted with your explicit consent. It is important to note that obtaining these permissions is a necessary prerequisite for
      us to provide the related functions, but obtaining a specific permission does not mean we will necessarily collect your relevant information; even if we have obtained a
      specific permission, we will only collect your relevant information when necessary and in accordance with this guidance.
    </p>
    <p>
      2.5 Please understand that the functions and services we provide to you are constantly updated and developed. If a certain function or service does not collect your
      information as mentioned above but does need to collect your information, we will explain the content, scope and purpose of information collection to you through
      updating this Agreement, page prompts, interactive processes, offline notifications and other means, and obtain your consent.
    </p>
    <strong><p>3.Explanation of user information disclosure</p></strong>
    <p>
      3.1 Respect for users 'personal privacy is a basic policy of {{ activationCompany.abbreviation }}. Therefore, {{ activationCompany.abbreviation }} will not disclose,
      edit or disclose users' registration information and non-public content stored in this application without the authorization of legal users, unless there are the
      following circumstances:
    </p>
    <p>（1）The relevant legal provisions or the necessary conditions for {{ activationCompany.abbreviation }} to perform its statutory duties or obligations;</p>
    <p>（2）those directly related to national security, national defense security, public security, public health and major public interests;</p>
    <p>（3）those directly related to criminal investigation, prosecution, trial and execution of judgment;</p>
    <p>（4）To safeguard {{ activationCompany.abbreviation }}'s trademark rights, patent rights and any other legitimate rights and interests;</p>
    <p>
      （5）In response to a public health emergency, or in an emergency situation to protect your or other individuals' life, property and other major legitimate rights and
      interests;
    </p>
    <p>
      （6）Process your personal information that you have disclosed or that has been legally disclosed within a reasonable scope in accordance with the Personal Information
      Protection Law of the People's Republic of China, except when you explicitly refuse. When the collected information has a significant impact on your personal rights and
      interests, we will obtain your consent according to law;
    </p>
    <p>（7）Collect personal information from legally disclosed information, such as legal news reports and government information disclosure channels;</p>
    <p>（8）To maintain the safe and stable operation of the products or services provided, such as discovering and dealing with faults of the products or services;</p>
    <p>（9）Other situations where personal information needs to be disclosed, edited or disclosed.</p>
    <strong><p>4.Information storage</p></strong>
    <p>
      <strong>
        <u>
          4.1 We will use various security measures at a reasonable level to protect your personal information. However, please understand that due to technological
          limitations and rapid development in the internet industry, as well as potential malicious attacks, even if {{ activationCompany.abbreviation }} does its utmost to
          enhance security measures, it cannot guarantee 100% safety of information. Therefore, we cannot ensure the security or integrity of any personal information
          transmitted over the internet.
        </u>
      </strong>
    </p>
    <p>
      4.2 Storage Location: We will store the personal information collected on servers in China in accordance with the requirements of applicable Chinese laws and
      regulations. Without your consent, we will not transmit your personal information to overseas.
    </p>
    <p>
      4.3 In general, we only store your information for the minimum period of time prescribed by law and will delete your information after the expiration date. However, in
      the following cases, we may change the storage time of personal information in order to comply with legal requirements:
    </p>
    <p>（1）To comply with applicable laws and regulations;</p>
    <p>（2）To comply with the provisions of court judgments, rulings or other legal procedures;</p>
    <p>（3）To comply with the requirements of relevant government agencies or legally authorized organizations;</p>
    <p>（4）We have reason to believe that we need to comply with relevant laws and regulations;</p>
    <p>
      （5）For the purpose of implementing relevant service agreements or this Guide, maintaining social and public interests, and protecting the personal and property safety
      or other legitimate rights and interests of our customers, us or affiliated companies, other users or employees.
    </p>
    <p>
      4.4 We will store your personal information in accordance with laws and regulations, and the user's personal information collected in China will be stored in China. At
      present, we will not transmit or store your personal information across borders. In the future, if we need to transmit or store your personal information across borders,
      we will do so in accordance with relevant laws and regulations.
    </p>
    <strong><p>5.Information disclosure and sharing</p></strong>
    <p>
      5.1 {{ activationCompany.abbreviation }} will not intentionally disclose, rent or sell your personal information and information to any third party. However, the
      following circumstances are excluded:
    </p>
    <p>（1）You agree to share information and information with third parties;</p>
    <p>（2）Only by disclosing your personal information and information can we provide you with certain products and services as required;</p>
    <p>
      （3）Should be provided at the request of the entity representing this application to offer products or services (unless we notify otherwise, such entities have no right
      to use your personal information and data for purposes other than offering products and services): as required by laws, regulations, or administrative orders; due to
      external audit needs; if you violate the terms of use of this application or any other product or service; if, after our assessment, your account is deemed risky and
      requires protection.
    </p>
    <p>
      5.2 When you use our services, you agree that your personal information can be disclosed to other teachers in the class and students in the class. In addition, we will
      not share your personal information with any third party companies, organizations or individuals, except in the following cases:
    </p>
    <p>（1）Sharing with your explicit consent: We will share your personal information with other parties upon obtaining your explicit consent.</p>
    <p>
      （2）We may share your personal information with other parties in accordance with laws and regulations or mandatory requirements of competent government authorities.
    </p>
    <p>
      （3）Sharing with our affiliates: Your personal information may be shared with {{ activationCompany.abbreviation }}'s affiliates. We will only share necessary personal
      information and it will be subject to the purposes stated in this Privacy Policy. If an affiliate wishes to change the purpose for which personal information is
      processed, they will seek your authorization and consent again.
    </p>
    <p>（4）Shared with products under the {{ activationCompany.abbreviation }} brand.</p>
    <strong><p>6.Your rights to your personal information</p></strong>
    <p>
      6.1 During your use of our products and services, to make it more convenient for you to access and manage information, and to ensure your right to close an account, we
      have provided corresponding operation settings in the client. You can follow the instructions within them to perform the necessary actions. Additionally, you may contact
      us through this policy to request access, correction, or deletion of your personal information.
    </p>
    <p>6.2 In the following circumstances, you may contact our customer service to request the deletion of the corresponding personal information:</p>
    <p>（1）We collect, store, use or provide personal information to the public in violation of laws, administrative regulations or agreements between the parties;</p>
    <p>（2）Collecting, storing, using or providing personal information beyond the scope of purpose or necessary time limit;</p>
    <p>（3）You withdraw your consent;</p>
    <p>（4）You terminate the use of all our products or services by means of cancellation.</p>
    <p>6.3 Respond to your request as above</p>
    <p>
      To ensure security, you may be required to provide a written request or otherwise prove your identity. We may require you to verify your identity before processing your
      request.
    </p>
    <strong><p>7.Care for minors</p></strong>
    <p>
      <strong>
        <u>
          We value the protection of minors' personal information. Due to the nature of this software, we do not provide it or its services to minors. During your use of our
          services, we assume that you have the corresponding capacity for civil conduct. If you are a minor, before using any related services of this software, you should
          carefully read this Privacy Policy under the supervision and guidance of your parents or other guardians, and provide us with your information only after obtaining
          their consent.
        </u>
      </strong>
    </p>
    <strong><p>8.Changes</p></strong>
    <p>
      <strong>
        <u>
          We may revise this guideline at appropriate times. When the terms of this guideline change, we will notify you of the updated privacy protection guidelines in an
          appropriate manner when the version is updated, and inform you of the effective date. Please read the revised privacy protection guidelines carefully. You need to
          agree to our handling of your personal information according to the updated privacy protection guidelines by clicking or checking the appropriate boxes again.
        </u>
      </strong>
    </p>
    <strong><p>9.How to contact us</p></strong>
    <p>
      If you have any questions, comments or suggestions about this Privacy Policy, please contact us through the following ways, and we will reply to you in a timely manner
      in accordance with the requirements of applicable laws and regulations:
    </p>
    <p>Company: {{ activationCompany.company }}</p>
    <p>Tel: 400-632-8880</p>
    <p>Contact person: customer service specialist</p>
    <p>Address: {{ activationCompany.address }}</p>
    <p>
      <strong>
        <u>
          We will review the issues involved as soon as possible and respond promptly after verifying your user identity. In most cases, we will reply to your request within
          15 working days. If we are unable to respond to your request, we will notify you and explain the reasons within the legal time limit. If you are dissatisfied with
          our response, especially if our handling of personal information has infringed upon your legitimate rights and interests, you can seek solutions through the
          following external channels: file a lawsuit with the local court where Dongguan {{ activationCompany.abbreviation }} Optoelectronic Materials Manufacturing Co., Ltd.
          is registered.。
        </u>
      </strong>
    </p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Andao Optoelectronic Materials Manufacturing Co., LTD',
        address: 'Building A, Building 11, Zone C, Songshan Lake International Finance Park, Dongguan City, Guangdong Province',
        abbreviation: 'Andao'
      }
    }
  },
  created() {
    // this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.primaryColor {
  color: #1e80ff;
}
</style>
